import axios from "axios";

const axiosInstance = axios.create({
    baseURL: "https://video-server-ar.herokuapp.com",
});

export default axiosInstance;
